import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable, of } from "rxjs";
import { HttpService } from "./http.service";
import { AuthService } from "app/auth-core/auth.service";
import { GroupItem, Recipe, ReceipeDTO, ReceiptItem, ReceiptItemDTO } from "app/models/recipe.model";
import { IngrediantService } from "./ingrediant.service";
import { map } from "rxjs/operators";


@Injectable({
	providedIn: 'root'
})
export class RecipeService {
	private baseUrl = environment.services.apiBasePath + "/SWITCH_FOOD_EX_RECIPES";
	private baseSwitchRecipesUrl = environment.services.apiBasePath + "/SWITCH_FOOD_EX_RECIPES/PUBLIC_RECIPES";
	constructor(private _httpService: HttpService, private _authService: AuthService, private _foodItemsService: IngrediantService) {
	}
	public getMyRecipes = (): Observable<Recipe[]> => {
		let url = this.baseUrl + "/" + this._authService.tokenUserId;
		return this._httpService.get(url, "json").pipe(
			map((res: ReceipeDTO[]) => {
				let result: Recipe[] = (res || []).map(recipe => this.fromDTOToRecipe(recipe));
				return result;
			}) 
		);
	}
	public getMyRecipe = (recipeId): Observable<Recipe> => {
		let url = this.baseUrl + "/" + this._authService.tokenUserId + "/" + recipeId;
		return this._httpService.get(url, "json").pipe(
			map((res: ReceipeDTO) => {
				let result: Recipe = this.fromDTOToRecipe(res);
				return result;
			}) 
		);
	}

	public getSwitchRecipes = (): Observable<Recipe[]> => {
		let url = this.baseSwitchRecipesUrl;
		return this._httpService.get(url, "json").pipe(
			map((res: ReceipeDTO[]) => {
				let result: Recipe[] = (res || []).map(recipe => this.fromDTOToRecipe(recipe));
				return result;
			}) 
		);
	}
	public getSwitchRecipe = (recipeId): Observable<Recipe> => {
		let url = this.baseSwitchRecipesUrl + "/" + recipeId;
		return this._httpService.get(url, "json").pipe(
			map((res: ReceipeDTO) => {
				let result: Recipe = this.fromDTOToRecipe(res);
				return result;
			}) 
		);
	}
	// public get = (id: any): Observable<Recipe> => {
	// 	let url = this.baseUrl + "/" + domain + "/new_landing_page_def/" + id;
	// 	return this._httpService.get(url);
	// }
	
	public delete = (id: any): Observable<any> => {
		let url = this.baseUrl + "/" + this._authService.tokenUserId + "/" + id;
		return this._httpService.delete(url);
	}
	public deleteSwitchRecipe = (id: any): Observable<any> => {
		let url = this.baseSwitchRecipesUrl + "/" + id;
		return this._httpService.delete(url);
	}
	public saveOrUpdate = (recipe: Recipe): Observable<any> => {
		let url = this.baseUrl + "/" + this._authService.tokenUserId;
		let toSave = this.fromRecipeToDTO(recipe);

		if (toSave.id)
			return this._httpService.put(url + "/" + toSave.id, toSave, "json");
		return this._httpService.post(url, toSave, "json");
	}

	public saveOrUpdateSwitchRecipe = (recipe: Recipe): Observable<any> => {
		let url = this.baseSwitchRecipesUrl;
		let toSave = this.fromRecipeToDTO(recipe);

		if (toSave.id)
			return this._httpService.put(url + "/" + toSave.id, toSave, "json");
		return this._httpService.post(url, toSave, "json");
	}
	

	public fromDTOToRecipe = (recipeDTO: ReceipeDTO): Recipe => {
		if (recipeDTO) {
			let result: Recipe = new Recipe();
			result.id = recipeDTO.id;
			result.recipeName = recipeDTO.recipeName;
			result.servings = recipeDTO.servings;
			result.envScoreClass = recipeDTO.envScoreClass;
			result.recipeLink = recipeDTO.recipeLink;
			result.ingrediants = [];
			recipeDTO.ingrediants.forEach((ing) => {
				let gItem: GroupItem = this._foodItemsService.getItem(ing.groupId, ing.subgroupId, ing.itemId);
				if (gItem) {
					let newItem: ReceiptItem = new ReceiptItem();
					Object.assign(newItem, gItem);
					newItem.label = ing.label;
					newItem.quantity = ing.quantity;
					newItem.measurementUnit = ing.measurementUnit;
					result.ingrediants.push(newItem);
				}
			})
			return result;
		}

		return null;
	} 

	public fromRecipeToDTO = (recipe: Recipe): ReceipeDTO => {
		if (recipe) {
			let result: ReceipeDTO = new ReceipeDTO();
			result.id = recipe.id;
			result.recipeName = recipe.recipeName;
			result.servings = recipe.servings;
			result.envScoreClass = recipe.envScoreClass;
			result.recipeLink = recipe.recipeLink;
			result.ingrediants = [];
			recipe.ingrediants.forEach((ing) => {
				let newItem: ReceiptItemDTO = new ReceiptItemDTO();
				newItem.label = ing.label;
				newItem.quantity = ing.quantity;
				newItem.measurementUnit = ing.measurementUnit;
				newItem.groupId = ing["FOOD COMMODITY GROUP"];
				newItem.subgroupId = ing["FOOD COMMODITY SUB-GROUP"];
				newItem.itemId = ing["FOOD COMMODITY ITEM"];
				result.ingrediants.push(newItem);
				
			})
			return result;
		}

		return null;
	}
	
}